import { mapState, mapGetters, mapActions, createNamespacedHelpers } from 'vuex'

//
// build getter/setter for mapGetters
//
export const mapSetter = (state, setters = {}) =>
    Object.keys(state).reduce((acc, stateName) => {
        acc[stateName] = {get: state[stateName]}
        if (setters[stateName]) acc[stateName].set = setters[stateName]
        return acc
    }, {})

export const authComputed = {
    ...mapState('auth', {
        currentUser: (state) => state.currentUser
    }),
    ...mapGetters('auth', ['loggedIn', 'developerMode'])
}

export const authMethods = mapActions('auth', ['logIn'])

const appGetter = [
    'devMode',
    'experimentalMode',
    'breakpoint',
    'theme',
    'language',
    'dense',
    'formatter',
    'tableConfig',
    'messages',
    'messagesCount',
    'tour',
    'dialogMaxWidth',
    'visibility'
]
const nsh = createNamespacedHelpers('app')
export const appComputed = {
    ...mapSetter(nsh.mapGetters(appGetter), {
        dense(dense) {
            this.$store.commit('app/SET_APP_DENSE', dense)
        }
    })
}

export const apiComputed = {
    ...mapGetters('api', [
        'userGroup',
        'organisation',
        'fetching',
        'canEdit',
        'canDelete',
        'isAdmin'
    ])
}
